import { ActionGroup } from '@porsche-code/kado-ui';
import {
  PButton,
  PButtonPure,
  PInputText,
} from '@porsche-design-system/components-react';
import { useEffect } from 'react';
import { useForm, type SubmitHandler } from 'react-hook-form';

import { clearSettings, getSettings, setSettings } from './helper';

type Inputs = {
  ppnuid: string;
};

export const AssumeUser = ({ onClose }: { onClose: () => void }) => {
  const settings = getSettings();

  const { register, handleSubmit, reset, resetField } = useForm<Inputs>({
    defaultValues: {
      ppnuid: settings?.ppnuid,
    },
  });

  const onSubmit: SubmitHandler<Inputs> = (data) => {
    if (data.ppnuid.length > 0) {
      setSettings(data);
    } else {
      clearSettings();
    }
    onClose();
    window.location.reload();
  };

  useEffect(() => {
    reset({ ppnuid: settings?.ppnuid });
  }, [settings?.ppnuid, reset]);

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <PInputText
        label="PPNUID"
        placeholder="mustermannma"
        {...register('ppnuid')}
      >
        <PButtonPure
          type="button"
          slot="end"
          icon="reset"
          hideLabel
          onClick={() => resetField('ppnuid', { defaultValue: '' })}
        />
      </PInputText>

      <ActionGroup>
        <PButton
          type="button"
          variant="secondary"
          icon="close"
          onClick={onClose}
        >
          Close
        </PButton>
        <PButton type="submit">Save</PButton>
      </ActionGroup>
    </form>
  );
};
